import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { subscribe } from 'alfa';

import AccountLoader from '../session/account';

const PrivateRoute = ({ component: Component, ...rest }) => {
  if (rest.user.requiresLogin() === false) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <AccountLoader>
            <Component {...props} />
          </AccountLoader>
        )}
      />
    );
  }

  return (
    <Route
      {...rest}
      render={({ location, location: { search } }) => (
        <Redirect
          to={{
            pathname: '/login',
            search,
            state: { from: location },
          }}
        />
      )}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any,
  location: PropTypes.shape({
    search: PropTypes.object,
  }),
};

export default subscribe(PrivateRoute, ['user']);
